export default "__VITE_ASSET__DdByZdJ$__"